module.exports = {
	"Browsers": {
		"Chrome": {
			"min": 52
		},
		"Firefox": {
			"min": 49
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./app/supported.yaml
// module id = 125
// module chunks = 0